/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.49
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Scope } from './Scope';
import {
    ScopeFromJSON,
    ScopeFromJSONTyped,
    ScopeToJSON,
} from './Scope';

/**
 * 
 * @export
 * @interface RoleWithFullScopes
 */
export interface RoleWithFullScopes {
    /**
     * 
     * @type {string}
     * @memberof RoleWithFullScopes
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof RoleWithFullScopes
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof RoleWithFullScopes
     */
    customerId: string;
    /**
     * 
     * @type {string}
     * @memberof RoleWithFullScopes
     */
    id: string;
    /**
     * 
     * @type {Array<Scope>}
     * @memberof RoleWithFullScopes
     */
    scopes: Array<Scope>;
}

/**
 * Check if a given object implements the RoleWithFullScopes interface.
 */
export function instanceOfRoleWithFullScopes(value: object): value is RoleWithFullScopes {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('customerId' in value) || value['customerId'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('scopes' in value) || value['scopes'] === undefined) return false;
    return true;
}

export function RoleWithFullScopesFromJSON(json: any): RoleWithFullScopes {
    return RoleWithFullScopesFromJSONTyped(json, false);
}

export function RoleWithFullScopesFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoleWithFullScopes {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'],
        'customerId': json['customerId'],
        'id': json['id'],
        'scopes': ((json['scopes'] as Array<any>).map(ScopeFromJSON)),
    };
}

export function RoleWithFullScopesToJSON(value?: RoleWithFullScopes | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'description': value['description'],
        'customerId': value['customerId'],
        'id': value['id'],
        'scopes': ((value['scopes'] as Array<any>).map(ScopeToJSON)),
    };
}

